import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'utils/i18n';

import ModalDialog from '../modal';

interface Props {
  isOpen: boolean;
  onClose: () => null;
}

const BasketExpiryModal: FC<Props> = ({ isOpen = false, onClose }) => {
  const { t } = useTranslation('common');
  const router = useRouter();

  return (
    <ModalDialog
      isOpen={isOpen}
      onClose={onClose}
      headerLabel={t('basket.expiry_warning_modal.header')}
      size="xsmall"
      primaryAction={
        <button
          onClick={() => {
            onClose();
            router.push(t('navigation.basket.url'));
          }}
          className="button button--secondary"
          data-testid="completeBooking"
        >
          {t('basket.expiry_warning_modal.complete_booking')}
        </button>
      }
      secondaryAction={
        <button
          onClick={onClose}
          className="button button--tertiary"
          data-testid="continueBrowsing"
        >
          {t('basket.expiry_warning_modal.continue_browsing')}
        </button>
      }
      showCloseIcon
    >
      <p data-testid="removalText">{t('basket.expiry_warning_modal.body')}</p>
    </ModalDialog>
  );
};

export default BasketExpiryModal;
